import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import { FormsySelect } from 'formsy-material-ui/lib';
import { HOC } from 'formsy-react';
import { numOfDaysInA } from '../../../../settings/other';
import globals from '../../../../globals/communityGlobals';

import { dropDownStyle, common } from '../../../../theme/AllocateBaseTheme';

const locale = globals.getAreas(['treatments', 'error']);

class DayOfMonthCalendar extends Component {
  handleMonthlySelect = (event, key, value) => {
    this.props.setValue({ [value]: { 1: true } });
  };
  generateMenuItems = () => {
    const monthlyOptions = [];
    for (let dayIndex = 0; dayIndex < numOfDaysInA.month; dayIndex += 1) {
      monthlyOptions.push(
        <MenuItem
          key={`specificTimeMonthlyOption${dayIndex}`}
          primaryText={dayIndex + 1}
          value={dayIndex.toString()}
        />,
      );
    }
    return monthlyOptions;
  };
  render() {
    const { getValue, disabled } = this.props;
    const value = getValue();
    const valueKeysArray = value ? Object.keys(value) : [];

    return (
      <FormsySelect
        required
        requiredError={locale.getMsg('requiredFieldValidationMessage')}
        name="dayOfTheMonth"
        floatingLabelText={`${locale.getMsg('dayOfTheMonth')}*`}
        value={valueKeysArray[0]}
        onChange={this.handleMonthlySelect}
        className="col-c3"
        floatingLabelStyle={common.floatingLabelStyle}
        floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
        floatingLabelFocusStyle={common.floatingLabelFocusStyle}
        underlineStyle={common.underlineStyle}
        style={dropDownStyle.style}
        errorStyle={common.errorStyle}
        iconStyle={dropDownStyle.iconStyle}
        labelStyle={dropDownStyle.labelStyle}
        menuStyle={dropDownStyle.menuStyle}
        disabled={disabled}
      >
        {this.generateMenuItems()}
      </FormsySelect>
    );
  }
}

DayOfMonthCalendar.defaultProps = {
  disabled: false,
};

DayOfMonthCalendar.propTypes = {
  getValue: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default HOC(DayOfMonthCalendar);
